import { render, staticRenderFns } from "./DropzoneCanvas.vue?vue&type=template&id=00dd1cc2"
import script from "./DropzoneCanvas.vue?vue&type=script&lang=js"
export * from "./DropzoneCanvas.vue?vue&type=script&lang=js"
import style0 from "./DropzoneCanvas.vue?vue&type=style&index=0&id=00dd1cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports